import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { CountDownTimerNewDesign } from "./count-down-timer-new-design";
import { HotelLastSecondIcon } from "./hotel-last-second-icon";
export const HotelLastSecondDiscountBox: React.FC<{
  size?: "small" | "large" | "medium";
  loading?: boolean;
  onTimeEnd?(): void;
}> = t0 => {
  const $ = _c(21);
  const {
    size: t1,
    loading,
    onTimeEnd
  } = t0;
  const size = t1 === undefined ? "small" : t1;
  if (size === "small") {
    let t2;
    if ($[0] !== size) {
      t2 = <HotelLastSecondIcon size={size} />;
      $[0] = size;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    const t3 = !loading;
    let t4;
    if ($[2] !== t3) {
      t4 = <CountDownTimerNewDesign showTimer={t3} resetOnEnd={true} className="!mt-0" boxSize="small" />;
      $[2] = t3;
      $[3] = t4;
    } else {
      t4 = $[3];
    }
    let t5;
    if ($[4] !== t2 || $[5] !== t4) {
      t5 = <div className="flex h-[118px] w-[170px] flex-col items-center justify-center gap-1 rounded-lg border border-[#ED071A1A] bg-[linear-gradient(191.68deg,_#FCD9DD_-0.52%,_#F78894_46.11%,_#E92525_99.07%)] bg-clip-padding px-3">{t2}{t4}</div>;
      $[4] = t2;
      $[5] = t4;
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    return t5;
  }
  if (size === "medium") {
    let t2;
    if ($[7] !== size) {
      t2 = <HotelLastSecondIcon size={size} />;
      $[7] = size;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    let t3;
    if ($[9] !== onTimeEnd) {
      t3 = <CountDownTimerNewDesign boxSize="small" className="!mt-0 !justify-end" onTimeEnd={onTimeEnd} />;
      $[9] = onTimeEnd;
      $[10] = t3;
    } else {
      t3 = $[10];
    }
    let t4;
    if ($[11] !== t2 || $[12] !== t3) {
      t4 = <div className="flex h-[60px] w-full items-center justify-between rounded-lg border border-[#ED071A1A] bg-[linear-gradient(177.07deg,_#FCD9DD_-19.34%,_#F78894_34.37%,_#E92525_95.4%)] bg-clip-padding px-4 md:pt-1">{t2}{t3}</div>;
      $[11] = t2;
      $[12] = t3;
      $[13] = t4;
    } else {
      t4 = $[13];
    }
    return t4;
  }
  let t2;
  if ($[14] !== size) {
    t2 = <HotelLastSecondIcon size={size} />;
    $[14] = size;
    $[15] = t2;
  } else {
    t2 = $[15];
  }
  let t3;
  if ($[16] !== onTimeEnd) {
    t3 = <CountDownTimerNewDesign boxSize="large" onTimeEnd={onTimeEnd} />;
    $[16] = onTimeEnd;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  let t4;
  if ($[18] !== t2 || $[19] !== t3) {
    t4 = <div className="mt-1 flex h-[98%] w-[200px] flex-col items-center justify-center rounded-2xl border border-[#ED071A1A] bg-[linear-gradient(191.68deg,_#FCD9DD_-0.52%,_#F78894_50.72%,_#E92525_99.07%)] bg-clip-padding">{t2}{t3}</div>;
    $[18] = t2;
    $[19] = t3;
    $[20] = t4;
  } else {
    t4 = $[20];
  }
  return t4;
};